module.exports = __webpack_public_path__ + "img/solution-data-banner.b8fb7c06.jpg";